import './Header.scoped.scss'

import { useAct } from 'FlowBuilder/store'
import BackLink from 'Shared/components/BackLink'
import EditableName from 'Shared/components/EditableName/EditableName'
import ServerWaitButton from 'Shared/components/ServerWaitButton'
import TopNav from './TopNav'
import { toast } from 'react-toastify'

import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import EmbedModal from './EmbedModal'

export default function Header() {
  const act = useAct()

  const { publicUrl, id, section, status } = useSel((s) => s.builder?.flow || {})
  const systemTemplate = useSel(s => s.builder.flowTemplate?.systemTemplate)
  const hasSurveyAction = useSel((s) => _.values(s.actions?.entities || {}).some(a => a.kind === 'survey'))
  const embeddableFlowsEnabled = window.ENV?.FEATURES?.embeddable_flows
  const isDirty = useSel((s) => s.local.isDirty)
  const isEditingTemplate = useSel((s) => s.local.isEditingTemplate)
  const validationErrors = useSel((s) => s.builder.validationErrors || [])
  const setupValidationErrors = useSel((s) => s.builder.setupValidationErrors || [])
  const templateValidationErrors = useSel((s) => s.builder.templateValidationErrors || [])
  const [cloneModalOpen, setCloneModalOpen] = useState(false)
  const [cloneFlowTemplateName, setCloneFlowTemplateName] = useState('')
  const [embedModalOpen, setEmbedModalOpen] = useState(false)

  const backLink = isEditingTemplate ? '/admin/settings/flow_templates' : `/admin/${section === 'ballots' ? 'ballots' : 'flows'}`

  const handleSave = () => {
    if (validationErrors.length > 0 || setupValidationErrors.length > 0 ||templateValidationErrors.length > 0) {
      [...validationErrors, ...setupValidationErrors, ...templateValidationErrors].forEach(error => {
        toast.error(error)
      })
      return Promise.reject(new Error('Validation errors present'))
    }
    return Promise.resolve(act.builder.persistAll())
  }

  return (
    <>
      <header>
        <div>
          <div className="flex-center gap-10">
            <BackLink href={backLink} />{' '}
            <EditableName
              modelName="flow"
              endpoint={`/api/flows/${id}`}
              noMarginBottom={true}
            />
          </div>
        </div>

        <div className="actions flex-center gap-12">
          { isEditingTemplate && <button className='button secondary' onClick={() => setCloneModalOpen(true)} disabled={isDirty}>Clone Template</button> }
          {embeddableFlowsEnabled && hasSurveyAction && !isEditingTemplate && (
            <>
              <button type='button' className='button naked embed-button' onClick={() => setEmbedModalOpen(true)}>
                <SvgIconsHtml /> Embed
              </button>
              <EmbedModal
                open={embedModalOpen}
                onCancel={() => setEmbedModalOpen(false)}
                publicUrl={publicUrl}
                status={status}
              />
            </>
          )}
          <a className={`button tertiary ${isDirty ? 'disabled' : ''}`} target='_blank' href={isDirty ? '' : `${publicUrl}?forget=1&checkAdmin=1`} rel="noreferrer">View</a>
          <BackdropModal open={cloneModalOpen} onCancel={() => setCloneModalOpen(false)} title='Clone Page Template'>
            <div className='form narrow'>
              <p>First, name your page template. This will help you find it later on so be sure to use a descriptive name.</p>
              <div className='field'>
                <label>Page template name</label>
                <input type='text' placeholder='Name your page template' value={cloneFlowTemplateName} onChange={(e) => setCloneFlowTemplateName(e.target.value)} />
              </div>
              <div className='flex-center gap-12'>
                <ServerWaitButton className='button block primary' onClick={() => act.builder.cloneFlowTemplate(cloneFlowTemplateName)} disabled={!cloneFlowTemplateName}>Clone</ServerWaitButton>
              </div>
            </div>
          </BackdropModal>
          <ServerWaitButton className='button red' onClick={act.builder.loadData} disabled={!isDirty}>Discard changes</ServerWaitButton>
          <ServerWaitButton className='button primary' onClick={handleSave} saveButton>Save</ServerWaitButton>
        </div>
      </header>
      { systemTemplate && isEditingTemplate && <div className='banner margin-bottom warning'>You're editing an in-built template managed by Movement, some options are not available</div> }
      <TopNav/>
    </>
  )
}
